<script>
  import Textfield from '@smui/textfield';
  import HelperText from '@smui/textfield/helper-text';
  import FormField from '@smui/form-field';
  import Checkbox from '@smui/checkbox';
  import Button, { Label } from '@smui/button';
  import { slide } from 'svelte/transition';
  import { createForm } from "svelte-forms-lib";
  import { deliveryAddress as schema } from './schemas.js';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let sameAddress;
  export let fields = {
    first_name:   '',
    last_name:    '',
    street:       '',
    building:     '',
    apartment:    null,
    city:         '',
    zipcode:      '',
    country:      'pl',
  };


  const { form, errors, handleSubmit, validateField } = createForm({
    initialValues: {...fields},
    validationSchema: schema,
    onSubmit: values => {
      if (!sameAddress) fields = values;
      dispatch('done');
    }
  });

  const customSubmit = e => {
    if (sameAddress) {
      e.preventDefault();
      dispatch('done');
    } else {
      handleSubmit(e);
    }
  }

</script>

<form on:submit={customSubmit}>
  
  <div class="row row-1">
    <FormField>
      <Checkbox bind:checked={sameAddress} />
      <span slot="label">Dostawa na ten sam adres.</span>
    </FormField>
  </div>

  {#if !sameAddress}
    <div transition:slide>
      <div class="row">
        <div class="cell">
          <Textfield bind:value={$form.first_name}
            variant="outlined"
            label="Imię"
            invalid={$errors.first_name}
            input$autocomplete="given-name"
            on:keyup={() => validateField('first_name')}>
            <HelperText persistent slot="helper">{$errors.first_name}</HelperText>
          </Textfield>
        </div>
        <div class="cell">
          <Textfield bind:value={$form.last_name}
            variant="outlined"
            label="Nazwisko"
            invalid={$errors.last_name}
            input$autocomplete="family-name"
            on:keyup={() => validateField('last_name')}>
            <HelperText persistent slot="helper" invalid>{$errors.last_name}</HelperText>
          </Textfield>
        </div>
      </div>

      <div class="row row-5 row-m3">
        <div class="cell">
          <Textfield bind:value={$form.street}
            variant="outlined"
            label="Ulica"
            invalid={$errors.street}
            input$autocomplete="address-line1"
            on:keyup={() => validateField('street')}>
            <HelperText persistent slot="helper" invalid>{$errors.street}</HelperText>
          </Textfield>
        </div>
        <div class="cell">
          <Textfield bind:value={$form.building}
            variant="outlined"
            label="Budynek"
            invalid={$errors.building}
            on:keyup={() => validateField('building')}>
            <HelperText persistent slot="helper" invalid>{$errors.building}</HelperText>
          </Textfield>
        </div>
        <div class="cell">
          <Textfield bind:value={$form.apartment}
            variant="outlined"
            label="Lokal"
            invalid={$errors.apartment}
            on:keyup={() => validateField('apartment')}>
            <HelperText persistent slot="helper" invalid>{$errors.apartment}</HelperText>
          </Textfield>
        </div>
      </div>

      <div class="row row-3 row-m2">
        <div class="cell">
          <Textfield bind:value={$form.city}
            variant="outlined"
            label="Miejscowość"
            invalid={$errors.city}
            input$autocomplete="address-line2"
            on:keyup={() => validateField('city')}>
            <HelperText persistent slot="helper" invalid>{$errors.city}</HelperText>
          </Textfield>
        </div>
        <div class="cell">
          <Textfield bind:value={$form.zipcode}
            variant="outlined"
            label="Kod pocztowy"
            invalid={$errors.zipcode}
            input$autocomplete="postal-code"
            on:keyup={() => validateField('zipcode')}>
            <HelperText persistent slot="helper" invalid>{$errors.zipcode}</HelperText>
          </Textfield>
        </div>
      </div>

      {#if false}
        <!-- until we will start using countries / should be parametrised in shop settings -->
        <div class="row">
          <div class="cell">
            <Textfield bind:value={$form.country}
              variant="outlined"
              label="Kraj"
              invalid={$errors.country}
              input$autocomplete="country">
              <HelperText persistent slot="helper" invalid>{$errors.country}</HelperText>
            </Textfield>
          </div>
        </div>
      {/if}
    </div>
  {/if}

  <Button type="submit" variant="raised">
    <Label>Dalej</Label>
  </Button>
</form>
